module.exports = __webpack_public_path__ + "img/foot.af5df546.jpg";